/*AOS.init({
    startEvent: 'DOMContentLoaded',
    once: true
});*/

// window.scrollTo(0, 5);

jQuery(document).ready( function (event) {

    if ( jQuery( '.tailored_journeys_section .tabs_list_select' ).length ) {
        let activeTab = jQuery( '.tailored_journeys_section .tabs_list_select .tabs_list_item.active p' ).text();
        jQuery( '.tailored_journeys_section .tabs_list_select > span' ).text( activeTab );
        jQuery( '.tailored_journeys_section .tabs_list_select  .tabs_list_item' ).on( 'click', function (event) {
            jQuery( '.tailored_journeys_section .tabs_list_select  .tabs_list_item' ).removeClass( 'active' );
            jQuery( this ).addClass( 'active' );
        });
    }


    var hpPopUpButton = document.querySelectorAll('.open-hp-popup');
    hpPopUpButton.forEach( (button) => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            var vimeoLink = e.target.getAttribute('href');
            var video_id_regExp = /^.*((youtu.be\/|vimeo.com\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/,
                match = vimeoLink.match(video_id_regExp),
                video_id;
            if (match&&match[7]){
                //valid
                video_id = match[7];
                console.log(video_id);
            }else{
                //invalid
                console.log("Invalid Video URL");
            }
            var iframe = '<iframe width="800" height="400" src="https://player.vimeo.com/video/' + video_id + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen=""></iframe>';
            var customersDetails = document.querySelector('.popup__customers--details');
            customersDetails.innerHTML = iframe;
            var popupcustomers = document.querySelector('.popup__customers');
            popupcustomers.classList.add('open');
            return false;
        });
    });

    /*jQuery("body,html").animate({
        scrollTop: 1
    }, 0);*/

    jQuery( '.discover-the-impact-block-columns, .discover-the-impact-block-columns-new' ).slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        // mobileFirst: true,
        arrows: true,
        dots: false,
        adaptiveHeight: true,
        infinite: true,
        // variableWidth: false,
        initialSlide: 0,
        accessibility: true,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    centerPadding: '5%',
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    centerPadding: '10%',
                    centerMode:true,
                    // centerPadding: '5%',
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    jQuery( '.hp-program-info-boxes-slider' ).slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        adaptiveHeight: true,
        infinite: true,
        variableWidth: false,
        initialSlide: 0,
        accessibility: true,
        centerMode: true,
        centerPadding: '23%',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: false,
                    centerPadding: '23%',
                }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
        ]
    });

    function add_class() {
        if (jQuery(window).width() < 769) {
            jQuery( '.slick-slide' ).removeClass('slick-hide');
            jQuery('.slick-current').prev().addClass('slick-hide');
        }

    }

    jQuery('#slider').on('swipe', function(event, slick, direction) {
        add_class();
    });

    jQuery('#slider').on('afterChange', function(event, currentSlide) {
        add_class();
    });

    add_class();
});

/*
jQuery(window).on('load resize orientationchange', function() {
    jQuery('.hp-program-info-boxes-slider').each(function(){
        var $carousel = jQuery(this);

        if (jQuery(window).width() > 768) {
            if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('unslick');
            }
        }
        else {

            if (!$carousel.hasClass('slick-initialized')) {
                $carousel.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    mobileFirst: true,
                    arrows: false,
                    dots: false,
                    adaptiveHeight: true,
                    infinite: true,
                    variableWidth: false,
                    initialSlide: 0,
                    accessibility: true,
                    centerMode:true,
                    centerPadding: '23%',
                });
            }
        }
    });
});*/
